import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { Heading, FormContainer } from './css';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import AccessToggle from './components/accessToggle';

const AccessControl = ({ formsControl, setFormsControl }) => {
  const {
    manageAccount: { labelAvailableForm, accessControlFormsList }
  } = useLocalizedStringsContext();

  useEffect(() => {
    if (formsControl && Object.keys(formsControl).length === 0) {
      const initialState = accessControlFormsList.reduce((acc, current) => {
        return { ...acc, [current.key]: false };
      }, {});

      setFormsControl(initialState);
    }
  }, []);

  return (
    <div>
      <Heading>{labelAvailableForm}</Heading>
      <FormContainer>
        {accessControlFormsList.map(item => (
          <AccessToggle
            data={item}
            formsControl={formsControl}
            setFormsControl={setFormsControl}
          />
        ))}
      </FormContainer>
    </div>
  );
};

AccessControl.propTypes = {
  formsControl: PropTypes.shape({}).isRequired,
  setFormsControl: PropTypes.func.isRequired
};

export default AccessControl;
